import api from "./api";

// Briefing editável (estilo Google Forms) — formulários montados pela gestão.

export type TipoCampoBriefing =
  | "texto" | "paragrafo" | "escolha_unica" | "caixas" | "lista" | "data" | "numero" | "sim_nao";

export const TIPOS_CAMPO_LABEL: Record<TipoCampoBriefing, string> = {
  texto: "Texto curto",
  paragrafo: "Parágrafo",
  escolha_unica: "Múltipla escolha (uma)",
  caixas: "Caixas de seleção (várias)",
  lista: "Lista suspensa",
  data: "Data",
  numero: "Número",
  sim_nao: "Sim / Não",
};

/** Tipos que usam a lista de opções. */
export const TIPOS_COM_OPCOES: TipoCampoBriefing[] = ["escolha_unica", "caixas", "lista"];

export interface CampoBriefing {
  id?: string;
  tipo: TipoCampoBriefing;
  rotulo: string;
  ajuda?: string | null;
  obrigatorio: boolean;
  opcoes?: string | string[] | null; // vem como JSON string do backend
  permiteOutro: boolean;
  ordem: number;
}

export interface FormularioBriefing {
  id: string;
  nome: string;
  descricao: string | null;
  tipoTarefaId: string | null;
  tipoProjetoSlug: string | null;
  ativo: boolean;
  ordem: number;
  campos: CampoBriefing[];
}

export interface RespostaBriefing {
  id: string;
  formularioId: string;
  tarefaId: string | null;
  projetoId: string | null;
  valores: string; // JSON
  preenchidoPor: string | null;
  atualizadoEm: string;
  formulario?: FormularioBriefing;
}

/** Opções sempre como array (o backend guarda JSON string). */
export function opcoesDoCampo(c: CampoBriefing): string[] {
  if (Array.isArray(c.opcoes)) return c.opcoes;
  if (typeof c.opcoes === "string" && c.opcoes.trim()) {
    try { const v = JSON.parse(c.opcoes); return Array.isArray(v) ? v : []; } catch { return []; }
  }
  return [];
}

export async function listarFormularios(opts?: { todos?: boolean; tipoTarefaId?: string; tipoProjetoSlug?: string }) {
  const qs = new URLSearchParams();
  if (opts?.todos) qs.append("todos", "1");
  if (opts?.tipoTarefaId) qs.append("tipoTarefaId", opts.tipoTarefaId);
  if (opts?.tipoProjetoSlug) qs.append("tipoProjetoSlug", opts.tipoProjetoSlug);
  const r = await api.get(`/briefings${qs.toString() ? `?${qs}` : ""}`);
  return r.data.data as FormularioBriefing[];
}

export async function criarFormulario(dados: Partial<FormularioBriefing> & { nome: string }) {
  const r = await api.post("/briefings", dados);
  return r.data.data as FormularioBriefing;
}

export async function atualizarFormulario(id: string, dados: Partial<FormularioBriefing>) {
  const r = await api.patch(`/briefings/${id}`, dados);
  return r.data.data as FormularioBriefing;
}

export async function excluirFormulario(id: string) {
  await api.delete(`/briefings/${id}`);
}

export async function duplicarFormulario(id: string) {
  const r = await api.post(`/briefings/${id}/duplicar`);
  return r.data.data as FormularioBriefing;
}

export async function listarRespostas(escopo: "tarefa" | "projeto", alvoId: string) {
  const r = await api.get(`/briefings/respostas/${escopo}/${alvoId}`);
  return r.data.data as RespostaBriefing[];
}

export async function salvarResposta(dados: {
  formularioId: string;
  tarefaId?: string;
  projetoId?: string;
  valores: Record<string, string | string[]>;
}) {
  const r = await api.post("/briefings/respostas", dados);
  return r.data.data as RespostaBriefing;
}
